import {appearances as appearanceApi} from '../../api';

export const REQUEST_APPEARANCE_GET_ACTION = 'REQUEST_APPEARANCE_GET_ACTION';
export const RECEIVE_APPEARANCE_GET_SUCCESS = 'RECEIVE_APPEARANCE_GET_SUCCESS';
export const RECEIVE_APPEARANCE_GET_FAILURE = 'RECEIVE_APPEARANCE_GET_FAILURE';

const requestAppearanceGet = () => ({
  type: REQUEST_APPEARANCE_GET_ACTION,
});

const receiveAppearanceGetSuccess = (appearance) => ({
  type: RECEIVE_APPEARANCE_GET_SUCCESS,
  payload: {
    appearance
  },
});

const receiveAppearanceGetFailure = (error) => ({
  type: RECEIVE_APPEARANCE_GET_FAILURE,
  payload: {
    error
  },
});

export const get = (id) =>
  (dispatch) => {
    dispatch(requestAppearanceGet());
    return appearanceApi.get(id)
      .then( (response) => {
        dispatch(receiveAppearanceGetSuccess(response.data));
      }).catch( (error) => {
        dispatch(receiveAppearanceGetFailure(error));
      });
  }



// WEBPACK FOOTER //
// ./src/appearances/actions/appearanceGetAction.js